export type EventOnChangeCanvasCursor = CustomEvent<void>;

export const getOnChangeCanvasCursorEvent = (): EventOnChangeCanvasCursor =>
  new CustomEvent("onChangeCanvasCursor", {
    bubbles: true,
  });
